import React from "react";
import Slider from "react-slick";
import "./SameProject.css";
import ListingCard from "../../ListingCard";
import { Link } from "react-router-dom";

function SameProject({ projectType }) {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const products = [
    {
      id: 1,
      image: "https://estate.deltaservis.com.tr/items/1/images/43.jpg",
      title: "Pendik Sahilde Trend Marmara Sitesinde Deniz Manzaralı 3+1",
      details: {
        buldingType: "Residence",
        room: "3+1",
        square: 130,
        floor: 1,
        age: 0,
      },
      location: "Pendik, İstanbul",
      district: "Batı Mahallesi / Pendik",
    },
    {
      id: 2,
      image: "https://estate.deltaservis.com.tr/items/2/images/44.jpg",
      title: "Pendik Sahilde Trend Marmara Sitesinde Deniz Manzaralı 3+1",
      details: {
        buldingType: "Residence",
        room: "3+1",
        square: 130,
        floor: 1,
        age: 0,
      },
      location: "Pendik, İstanbul",
      district: "Batı Mahallesi / Pendik",
    },
    {
      id: 5,
      image: "https://estate.deltaservis.com.tr/items/5/images/1.jpg",
      title: "Tuzla Mimar Sinan'da Presjtijli Dükkanlar",
      details: {
        buldingType: "Store",
        room: "3+1",
        square: 285,
        floor: 1,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Mimar Sinan / Tuzla",
    },
    {
      id: 6,
      image: "https://estate.deltaservis.com.tr/items/6/images/2.jpg",
      title: "Tuzla Mimar Sinan'da Presjtijli Dükkanlar",
      details: {
        buldingType: "Store",
        room: "3+1",
        square: 274,
        floor: 1,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Mimar Sinan / Tuzla",
    },
    {
      id: 7,
      image: "https://estate.deltaservis.com.tr/items/6/images/3.jpg",
      title: "Tuzla Mimar Sinan'da Presjtijli Dükkanlar",
      details: {
        buldingType: "Store",
        room: "3+1",
        square: 210,
        floor: 1,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Mimar Sinan / Tuzla",
    },
    {
      id: 8,
      image: "https://estate.deltaservis.com.tr/items/7/images/4.jpg",
      title: "Tuzla Mimar Sinan'da Presjtijli Dükkanlar",
      details: {
        buldingType: "Store",
        room: "3+1",
        square: 155,
        floor: 1,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Mimar Sinan / Tuzla",
    },
    {
      id: 9,
      image: "https://estate.deltaservis.com.tr/items/9/images/1.jpg",
      title: "Modern Park Evleri A1 Tip",
      details: {
        buldingType: "Villa",
        room: "7+3",
        square: 530,
        floor: 3,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Aydınlı / Tuzla",
    },
    {
      id: 10,
      image: "https://estate.deltaservis.com.tr/items/10/images/2.jpg",
      title: "Modern Park Evleri A2 Tip",
      details: {
        buldingType: "Villa",
        room: "5+2",
        square: 450,
        floor: 3,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Aydınlı / Tuzla",
    },
    {
      id: 11,
      image: "https://estate.deltaservis.com.tr/items/11/images/3.jpg",
      title: "Modern Park Evleri A3 Tip",
      details: {
        buldingType: "Villa",
        room: "5+2",
        square: 450,
        floor: 3,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Aydınlı / Tuzla",
    },
    {
      id: 12,
      image: "https://estate.deltaservis.com.tr/items/12/images/4.jpg",
      title: "Modern Park Evleri A4 Tip",
      details: {
        buldingType: "Villa",
        room: "5+2",
        square: 450,
        floor: 3,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Aydınlı / Tuzla",
    },
    {
      id: 13,
      image: "https://estate.deltaservis.com.tr/items/13/images/5.jpg",
      title: "Modern Park Evleri B1 Tip",
      details: {
        buldingType: "Villa",
        room: "7+3",
        square: 530,
        floor: 3,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Aydınlı / Tuzla",
    },
    {
      id: 14,
      image: "https://estate.deltaservis.com.tr/items/14/images/6.jpg",
      title: "Modern Park Evleri B2 Tip",
      details: {
        buldingType: "Villa",
        room: "5+2",
        square: 450,
        floor: 3,
        age: 0,
      },
      location: "Tuzla, İstanbul",
      district: "Aydınlı / Tuzla",
    },
  ];
  const filteredListings = products.filter(
    (item) => item.details.buldingType === projectType
  );

  return (
    <div className="container-xl residence-slider my-5">
      <h2 className="featured-title text-left">Benzer İlanlar</h2>
      <Slider {...settings}>
        {filteredListings.map((listing) => (
          <ListingCard key={listing.id} listing={listing} />
        ))}
      </Slider>

      <div className="text-center mb-5">
        <Link to="/projeler">
          <div className="more-button m-auto">Daha Fazla</div>
        </Link>
      </div>
    </div>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className="arrow next" onClick={onClick}>
      ›
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="arrow prev" onClick={onClick}>
      ‹
    </div>
  );
}

export default SameProject;
